module.exports = __webpack_public_path__ + "static/media/opened-eye.e6d189ec.svg";